import { CultureListComponent } from './../culture-list/culture-list.component';
import { RecetteComponent } from './recette.component';
import { NgModule } from '@angular/core';
import { ThemeModule } from '../../@theme/theme.module';
import { RecetteListComponent } from './recette-list/recette-list.component';
import { RecetteItemComponent } from './recette-list/recette-item/recette-item.component';


@NgModule({
  imports: [
    ThemeModule,
  ],
  declarations: [
    RecetteComponent,
    RecetteListComponent,
    RecetteItemComponent,
    CultureListComponent,
  ],
})
export class RecetteModule { }
